import moment from 'moment'

const EMPTY = '-'

export const LABEL_MAX_LENGTH = 8

/**
 * ラベルを最大文字数で切り詰め、超過分を省略記号（…）にする純関数。
 */
export function truncateLabel(value: string | null | undefined, maxLength = LABEL_MAX_LENGTH): string {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  return [...value].length > maxLength ? `${[...value].slice(0, maxLength).join('')}…` : value
}

/**
 * 日付を `YYYY/MM/DD` 形式に整形する純関数。
 */
export function formatDate(value: string | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return EMPTY
  }
  const m = moment(value)
  return m.isValid() ? m.format('YYYY/MM/DD') : EMPTY
}

/**
 * 数値を 3 桁区切りに整形する純関数
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return EMPTY
  }
  return value.toLocaleString('ja-JP')
}

/**
 * 当選人数を整形する純関数。0 は AI が記載を検出できなかった「判別不可」を意味するため「-」を表示する。
 */
export function formatWinnerCount(value: number | null | undefined): string {
  if (value === null || value === undefined || value === 0) {
    return EMPTY
  }
  return value.toLocaleString('ja-JP')
}

/**
 * 数値を `12.34%` のようなパーセント表記に整形する純関数
 */
export function formatPercent(value: number | null | undefined, fractionDigits = 2): string {
  if (value === null || value === undefined) {
    return EMPTY
  }
  return `${value.toFixed(fractionDigits)}%`
}

/**
 * 日時を `YYYY年M月D日 HH:mm` 形式に整形する純関数（投稿日時など詳細ドロワーの表示用）。
 */
export function formatDateTime(value: string | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return EMPTY
  }
  const m = moment(value)
  return m.isValid() ? m.format('YYYY年M月D日 HH:mm') : EMPTY
}

/**
 * 日時を `YYYY年MM月DD日 HH:mm` 形式（ゼロ埋め）に整形する純関数（キャンペーン一覧画面の期間表示と揃えるため）。
 */
export function formatDateTimePadded(value: string | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return EMPTY
  }
  const m = moment(value)
  return m.isValid() ? m.format('YYYY年MM月DD日 HH:mm') : EMPTY
}

/**
 * 日時を `YYYY/MM/DD HH:mm` 形式に整形する純関数（詳細ドロワーの更新日時表示用）。
 */
export function formatDateTimeShort(value: string | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return EMPTY
  }
  const m = moment(value)
  return m.isValid() ? m.format('YYYY/MM/DD HH:mm') : EMPTY
}

/**
 * トレンド実績の日時を `M/D H時` 形式に整形する純関数。
 */
export function formatTrendDate(value: string | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return EMPTY
  }
  const m = moment(value)
  return m.isValid() ? m.format('M/D H時') : EMPTY
}

/**
 * 開始日・終了日を `開始 〜 終了` 形式に整形する純関数。
 */
export function formatDateRange(
  start: string | Date | null | undefined,
  end: string | Date | null | undefined
): string {
  const hasStart = start !== null && start !== undefined && start !== ''
  const hasEnd = end !== null && end !== undefined && end !== ''
  if (!hasStart && !hasEnd) {
    return EMPTY
  }
  return `${formatDate(start)} 〜 ${formatDate(end)}`
}
